import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box } from '@mui/material';
import { sxStyle } from './styles';

export default function ImageHeader({ image }) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
  };

  return (
    <Box sx={sxStyle.sliderContainer}>
      <Slider {...settings}>
        <Box sx={sxStyle.slide}>
          <Box component="img" src={image} alt="" sx={sxStyle.img} />
        </Box>
      </Slider>
    </Box>
  );
}
